import { useState } from "react";
import Button from "../Component/Common/Button";
import Input from "../Component/Common/Input";
import Logo from "../assets/images/MetubeLogo.png";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../store/admin/admin.action";
import LoginImg from "../assets/images/loginPage.png";

import { connect } from "react-redux";
import { projectName } from "../util/config";
import { orgLogin } from "../store/organization/organization.action";

const Login = (props) => {
  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = () => {
    if (!email || !password) {
      let error = {};
      if (!email) error.email = "Email Is Required !";
      if (!password) error.password = "password is required !";
      return setError({ ...error });
    } else {
      let login = {
        email,
        password,
      };

      if (!props.isOrgLogin) {
        console.log("Admin Login");
        props.loginAdmin(login);
      } else {
        console.log("Organization Login");
        props.orgLogin(login);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <>
      <div className="login-page-content">
        <div className="bg-login">
          <div className="login-page-box">
            <div className="row">
              <div className="col-12 col-md-6 right-login-img">
                <img src={LoginImg} />
              </div>
              <div className="col-12 col-md-6 text-login">
                <div className="heading-login">
                  <img src={Logo} />
                  <h6>{projectName}</h6>
                </div>
                <div className="login-left-form">
                  <span>Welcome back !!!</span>
                  <h5>{props.isOrgLogin ? "Sign in to your organization account" : "Admin Login"}</h5>
                  <Input
                    label={`Email`}
                    id={`loginEmail`}
                    type={`email`}
                    value={email}
                    errorMessage={error.email && error.email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          email: `Email Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          email: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <Input
                    label={`Password`}
                    id={`loginPassword`}
                    type={`password`}
                    value={password}
                    errorMessage={error.password && error.password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          password: `Password Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          password: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <div className="text-end">
                    <a
                      className="text-secondary text-decoration-underline cursor"
                      onClick={() => {
                        sessionStorage.setItem("userType", props.isOrgLogin ? 1 : 0);
                        navigate("/forgotPassword");
                      }}
                    >
                      Forgot Password
                    </a>
                  </div>
                  <div className="d-flex justify-content-center w-100">
                    <Button onClick={handleSubmit}>LOGIN</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { loginAdmin, orgLogin })(Login);
